export default "__VITE_ASSET__a6YPJWHw__"